export const { REACT_APP_MODE } = process.env;

export const APP_DESCRIPTION = process.env.REACT_APP_DESCRIPTION;
export const APP_TITLE = process.env.REACT_APP_TITLE;
export const APP_VERSION = process.env.REACT_APP_VERSION ?? '';

export const CHROME_EXTENSION_ID = process.env.REACT_APP_CHROME_EXTENSION_ID;
export const CHROME_EXTENSION_TOUR_ID = process.env.REACT_APP_CHROME_EXTENSION_TOUR_ID;

export const DATADOG_APPLICATION_ID = process.env.REACT_APP_DATADOG_APPLICATION_ID;
export const DATADOG_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
export const DATADOG_IS_ENABLED = +(process.env.REACT_APP_DATADOG_IS_ENABLED ?? 0);
export const DATADOG_SAMPLE_RATE = +(process.env.REACT_APP_DATADOG_SAMPLE_RATE ?? 0);
export const DATADOG_SERVICE = process.env.REACT_APP_DATADOG_SERVICE;
export const DATADOG_SESSION_REPLAY_SAMPLE_RATE = +(process.env.REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE ?? 0);

export const ENABLE_US_API = process.env.REACT_APP_ENABLE_US_API || '';
export const ENABLE_US_VENDOR_ID = process.env.REACT_APP_ENABLE_US_VENDOR_ID;
export const ENABLE_US_WEB = process.env.REACT_APP_ENABLE_US_WEB ?? '';
export const ASSET_LIB_GQL_ENDPOINT = process.env.REACT_APP_ASSET_LIB_GQL_ENDPOINT || '';

export const FEDERATION_HOST_GET_SUPPORT = process.env.REACT_APP_FEDERATION_HOST_GET_SUPPORT || '';
export const FEDERATION_REMOTE_ENTRY = process.env.REACT_APP_FEDERATION_REMOTE_ENTRY || '';

export const EXTERNAL_SHARING_REMOTE_ENTRY = process.env.REACT_APP_EXTERNAL_SHARING_REMOTE_ENTRY || '';

export const COPILOT_CHAT_UI_REMOTE_ENTRY =
  process.env.REACT_APP_FEDERATION_HOST_COPILOT_CHAT_UI ||
  'https://assets.mindtickle.com/copilot-chat-ui/prod/production/remoteEntry.js';

export const ASSET_LIBRARY_WC_REMOTE_ENTRY =
  process.env.REACT_APP_FEDERATION_HOST_ASSET_LIBRARY_WC || '';

export const GOOGLE_FONTS_API_KEY = process.env.REACT_APP_GOOGLE_FONTS_API_KEY || '';
export const GOOGLE_FONTS_API_URL = process.env.REACT_APP_GOOGLE_FONTS_API_URL || '';
export const GOOGLE_FONTS_CSS_URL = process.env.REACT_APP_GOOGLE_FONTS_CSS_URL || '';
export const GOOGLE_RECAPTCHA_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY || '';

export const HOST = process.env.REACT_APP_HOST ?? '';

export const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;
export const INTERCOM_IS_ENABLED = +(process.env.REACT_APP_INTERCOM_IS_ENABLED ?? 0);

export const LOCAL_I18N_FILES_ENABLED = +(process.env.REACT_APP_LOCAL_I18N_FILES_ENABLED ?? 0);

export const MIXPANEL_IS_ENABLED = +(process.env.REACT_APP_MIXPANEL_IS_ENABLED ?? 0);
export const MIXPANEL_PROJECT_TOKEN = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN;

export const MULTI_REGION_COOKIE_NAME = process.env.REACT_APP_MULTI_REGION_COOKIE_NAME;

export const REFERENCEABLE_API = process.env.REACT_APP_REFERENCEABLE_API;
export const RINGCENTRAL_CLIENT_ID = process.env.REACT_APP_RINGCENTRAL_CLIENT_ID;
export const RINGCENTRAL_SERVER = process.env.REACT_APP_RINGCENTRAL_SERVER;

export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;

export const TINY_MCE_SRC = process.env.REACT_APP_TINY_MCE_SRC;


export const TRACK = process.env.REACT_APP_TRACK || '';

export const TRACKING_IDENTIFY_PREFIX = process.env.REACT_APP_TRACKING_IDENTIFY_PREFIX;

export const VENDOR_MODE_IS_ENABLED = +(process.env.REACT_APP_VENDOR_MODE_IS_ENABLED ?? 0);

export const ZIPY_IS_ENABLED = +(process.env.REACT_APP_ZIPY_IS_ENABLED ?? 0);
export const ZIPY_PROJECT_ID = process.env.REACT_APP_ZIPY_PROJECT_ID;

export const UI_SHELL_TRACK = process.env.REACT_APP_UI_SHELL_TRACK || '';
export const UI_SHELL_REMOTE_ENTRY = process.env.REACT_APP_UI_SHELL_REMOTE_ENTRY || '';

export const HIDE_ORGANIZATIONS_TAB_FOR_SITE = process.env.REACT_APP_HIDE_ORGANIZATIONS_TAB_IN_DSR || '';

export const UI_ASSETS_CDN_FONTS_STENCIL_URL = process.env.REACT_APP_UI_ASSETS_CDN_FONTS_STENCIL_URL || '';
export const UI_ASSETS_CDN_STYLES_STENCIL_URL = process.env.REACT_APP_UI_ASSETS_CDN_STYLES_STENCIL_URL || '';
export const UI_ASSETS_CDN_FONTAWESOME_STENCIL_URL = process.env.REACT_APP_UI_ASSETS_CDN_FONTAWESOME_STENCIL_URL || '';